"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useEffect, useState } from "react";
import { Clock, User, Calendar } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function ArticleHero() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return <section data-section-id="25513" id="article-hero" className="relative h-screen w-full overflow-hidden bg-secondary text-foreground">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden rounded-2xl">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618354/img/messi_god_ray_action.png" alt="Lionel Messi World Cup Victory" className="h-full w-full object-cover object-center rounded-2xl" />
        {}
        <div className="absolute inset-0 bg-primary/5 mix-blend-overlay" />
        {}
        <div className="absolute inset-0 bg-primary/10" />
      </div>

      {}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        
        {}
        <div className={`mb-6 transform transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <span className="font-sans text-sm font-bold uppercase tracking-widest text-chart-2 drop-shadow-sm">
            Interior Design
          </span>
        </div>

        {}
        <h1 className={`mb-8 max-w-4xl font-default text-5xl font-medium leading-tight text-primary tracking-tight drop-shadow-sm md:text-7xl lg:text-[80px] transform transition-all duration-1000 delay-150 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          The Art of Organic Precision
        </h1>

        {}
        <div className={`mb-8 flex justify-center transform transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <Separator className="h-px w-20 bg-chart-2/40" />
        </div>

        {}
        <div className={`flex flex-wrap items-center justify-center gap-4 font-sans text-sm font-light uppercase tracking-widest text-primary/80 md:gap-6 transform transition-all duration-1000 delay-450 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <div className="flex items-center gap-2">
            <User className="h-4 w-4 text-chart-2" />
            <Link to="/AboutDiscoveryPage" className="hover:text-chart-2 transition-colors">
              Studio Editorial
            </Link>
          </div>
          
          <span className="hidden h-1 w-1 rounded-full bg-chart-2/60 md:block" />
          
          <div className="flex items-center gap-2">
            <SafeHydrate><Calendar className="h-4 w-4 text-chart-2" /></SafeHydrate>
            <span>October 12, 2023</span>
          </div>

          <span className="hidden h-1 w-1 rounded-full bg-chart-2/60 md:block" />

          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-chart-2" />
            <span>6 min read</span>
          </div>
        </div>
      </div>
    </section>;
}